import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";

import FriendsTab from "./FriendsTab";
import LeaderboardTab from "./LeaderboardTab";
import CompetitionsTab from "./CompetitionsTab";
import DraftsTab from "./DraftsTab";
import AgentsRow from "./AgentsRow";
import MatchmakingRow from "./MatchmakingRow";
import { getFriendsList, getGlobalLeaderboard } from "../../api/communityApi";

const Community = () => {
  const [activeTab, setActiveTab] = useState("friends");
  const [stats, setStats] = useState({
    friends: 0,
    competitions: 0, // Mock for now since there's no competitions API
    rank: "Unranked",
    xp: 0, // Mock for now
  });

  const tabs = [
    { id: "friends", label: "Friends" },
    { id: "leaderboard", label: "Leaderboard" },
    { id: "competitions", label: "Competitions" },
    { id: "drafts", label: "Stock Drafts" },
  ];

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [friendsData, leaderboardData] = await Promise.all([
          getFriendsList(),
          getGlobalLeaderboard()
        ]);
        
        let rankStr = "Unranked";
        if (leaderboardData.my_rank) {
          const rank = leaderboardData.my_rank.rank;
          const total = leaderboardData.total_users || 1;
          const topPercent = Math.max(1, Math.round((rank / total) * 100));
          rankStr = `Top ${topPercent}% (#${rank})`;
        }

        setStats(prev => ({
          ...prev,
          friends: friendsData.count || 0,
          rank: rankStr,
          xp: 1240 // Place holder for XP
        }));
      } catch (error) {
        console.error("Failed to fetch community stats", error);
      }
    };
    fetchStats();
  }, []);

  return (
    <>
      <Navbar />

      {/* Background */}
      <div className="min-h-screen bg-white dark:bg-gradient-to-b dark:from-gray-900 dark:via-gray-950 dark:to-black text-black dark:text-white pt-24 pb-16 transition">

        {/* Container */}
        <div className="max-w-[1500px] mx-auto px-4 sm:px-6">

          {/* PAGE HEADER */}
          <div className="mb-10 animate-fadeIn">
            <h1 className="text-3xl sm:text-4xl font-bold">FinAI Community</h1>
            <p className="text-gray-600 dark:text-gray-400 mt-1">
              Connect with investors, join competitions, and climb the leaderboard.
            </p>

            {/* USER STATS */}
            <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
              <div className="p-4 bg-gray-100 dark:bg-gray-800 rounded-xl border border-gray-300 dark:border-gray-700 shadow hover:shadow-lg transition">
                <p className="text-sm text-gray-500">Friends</p>
                <h2 className="text-2xl font-bold">{stats.friends}</h2>
              </div>

              <div className="p-4 bg-gray-100 dark:bg-gray-800 rounded-xl border border-gray-300 dark:border-gray-700 shadow hover:shadow-lg transition">
                <p className="text-sm text-gray-500">Competitions</p>
                <h2 className="text-2xl font-bold">{stats.competitions}</h2>
              </div>

              <div className="p-4 bg-gray-100 dark:bg-gray-800 rounded-xl border border-gray-300 dark:border-gray-700 shadow hover:shadow-lg transition">
                <p className="text-sm text-gray-500">Global Rank</p>
                <h2 className="text-xl font-semibold text-indigo-400">{stats.rank}</h2>
              </div>

              <div className="p-4 bg-gray-100 dark:bg-gray-800 rounded-xl border border-gray-300 dark:border-gray-700 shadow hover:shadow-lg transition">
                <p className="text-sm text-gray-500">XP Level</p>
                <h2 className="text-xl font-bold">{stats.xp} XP</h2>
              </div>
            </div>
          </div>

          {/* TABS */}
          <div className="flex overflow-x-auto space-x-4 border-b border-gray-300 dark:border-gray-700 mb-8 pb-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  px-5 py-2 rounded-lg transition font-medium whitespace-nowrap
                  ${
                    activeTab === tab.id
                      ? "bg-indigo-600 text-white shadow"
                      : "text-gray-500 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-800"
                  }
                `}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* AI AGENTS ROW — featured */}
          <AgentsRow />

          {/* MATCHMAKING ROW — investors like you */}
          <MatchmakingRow />

          {/* CONTENT AREA */}
          <div className="animate-fadeIn">
            {activeTab === "friends" && <FriendsTab />}
            {activeTab === "leaderboard" && <LeaderboardTab />}
            {activeTab === "competitions" && <CompetitionsTab />}
            {activeTab === "drafts" && <DraftsTab />}
          </div>

        </div>
      </div>
    </>
  );
};

export default Community;
